import { useDataChange } from 'Simple/Data.js'

function stripHtmlTags(str) {
  if (typeof str !== 'string') return ''
  return str.replace(/<[^>]*>/g, '')
}

export function useDataOnChange(props) {
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
    path: 'data.description',
  })

  return function onChange(value) {
    change(stripHtmlTags(value))
  }
}

export function getToolbar(tokens) {
  return tokens?.items?.length ? 'sms_template' : false
}
